import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import * as React from 'react';
const isMobile = window.matchMedia('(max-width: 768px)').matches;
import { UXPContext } from '@core/context/Context';
const Width = 1200;
const ResponsivePage = (props) => {
    let { widget, embedded } = props;
    const [width, setWidth] = React.useState(Width);
    const numClos = 30;
    const margin = [10, 10];
    let context = React.useContext(UXPContext);
    let mainContainerRef = React.useRef(null);
    let observer = new MutationObserver((e) => {
        // console.log("mutation event : ", e)
        updateWidth();
    });
    React.useEffect(() => {
        updateWidth();
        let mainBlock = mainContainerRef.current;
        // console.log(mainBlock)
        observer.observe(mainBlock, {
            attributes: true,
            attributeFilter: ['class'],
            childList: false,
            characterData: false
        });
    }, []);
    const updateWidth = () => {
        var _a;
        // console.log("Updating width")
        let _width = ((_a = mainContainerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || Width;
        if (_width < Width && !isMobile && !embedded)
            _width = Width;
        setWidth(_width - 20);
    };
    function renderWidget() {
        if (!widget)
            return null;
        const cellHeight = (width - (margin[0] * (numClos + 1))) / numClos;
        // calculate width height for the widget 
        let layout = widget.layout;
        let { w, h } = layout || { w: 6, h: 6 };
        let padding = 20;
        // let _w = (width /30) * w
        // let _h = (width /30) * h
        let _w = (cellHeight * w) + (padding * 2);
        let _h = (cellHeight * h) + (padding * 2) + (2 * h);
        if (isMobile || embedded) {
            _w = '100%';
            _h = '100%';
            padding = 0;
        }
        let styles = {
            width: _w,
            height: _h,
            padding: padding
        };
        return _jsx("div", { className: classNames("uxp-responsive-page-container", { 'mobile': (embedded || isMobile) }), style: styles, children: _jsx(widget.component, Object.assign({}, (widget.configuredProps || {}), { uxpContext: context, instanceId: widget.key })) });
    }
    return _jsx("div", { className: "main-block render-ui", children: _jsx("div", { className: classNames("content-block", "no-header"), children: _jsx("div", { className: classNames("main-content-block"), ref: mainContainerRef, children: renderWidget() }) }) });
};
export default ResponsivePage;
